p, h1, h2, h3, h4, span, a, hr {
  @include text-main;
  color: var(--color-dark-grey);
}
